// UserMenu.vue
<template>
  <div v-if="showOptions">
    <!-- Club -->
    <div
      class="item"
      id="club"
      @click="onClubClick"
      :class="{ active: activePage === 'club' }"
    >
        <p class="name" v-if="user.team && user.team.club">
        {{ user.team.club.name }}
        </p>
        <p class="name" v-else-if="club">
        {{ club.name }}
        </p>
    </div>

    <!-- Club payments -->
    <div class="item">
      <div class="submenu">
        <MenuItem
          v-if="!integra"
          label="titles.payments_and_budget"
          :active="activePage === 'club-payments'"
          @click="$emit('redirect', {routeName: 'club-payments'})"
        />
      </div>
    </div>

    <!-- Team loop -->
    <template>
      <div
       v-for="(group, catKey) in categories"
       :key="catKey"
     >
       <TeamMenuGroup
         v-for="(team, teamId) in group"
         :key="teamId"
         :user="user"
         :team="team"
         :teamKey="teamId"
         :event="event"
         :activePage="activePage"
         :selectedTeam="selectedTeam"
         @redirect="$emit('redirect', $event)"
         @collapse="$emit('collapse', $event)"
         @changeTeam="$emit('changeTeam', teamId)"
       >
      </TeamMenuGroup>
     </div>
    </template>

    <!-- Rules & Groups -->
    <RuleItem
      v-if="showRules"
      label="rules_doc"
      @click="$emit('openRules')"
    />
    <RuleItem
      v-if="showGroups || showCalendar"
      label="titles.tournament_competition_system"
      @click="$emit('openCompetitionSystem')"
    />
    <RuleItem
      v-if="showGroups"
      label="titles.tournament_file_groups"
      @click="$emit('openGroups')"
    />
    <RuleItem
      v-if="showCalendar"
      label="titles.tournament_file_groups_calendar"
      @click="$emit('openCalendar')"
    />
    <RuleItem
      v-if="showProtocolChildren"
      label="titles.volunteer_protocol_children"
      @click="$emit('openProtocolChildren')"
    />
  </div>
</template>

<script>
import MenuItem from '@/components/domain/home/left-menu/MenuItem.vue'
import RuleItem from '@/components/domain/home/left-menu/RuleItem.vue'
import TeamMenuGroup from '@/components/domain/home/left-menu/TeamMenuGroup.vue'

export default {
  name: 'UserMenu',
  props: {
    user: Object,
    club: Object,
    categories: Object,
    event: {
      type: Object,
      default: () => ({})
    },
    activePage: String,
    selectedTeam: String,
    integra: Boolean,
    showOptions: Boolean,
    changeClub: Boolean
  },
  components: { MenuItem, RuleItem, TeamMenuGroup },
  computed: {
    showRules () {
      return [].includes(parseInt(this.event.type_id))
    },
    showGroups () {
      return [].includes(parseInt(this.event.type_id)) && !this.integra
    },
    showCalendar () {
      return [].includes(parseInt(this.event.type_id)) && !this.integra
    },
    showProtocolChildren () {
      return parseInt(this.event.type_id) === 1 || parseInt(this.event.type_id) === 17
    }
  },
  methods: {
    onClubClick () {
      // first collapse every category
      this.$emit('collapse', '')
      // then navigate to Club
      this.$emit('redirect', { routeName: 'club' })
    }
  }
}
</script>

<style lang="scss" scoped src="@/styles/_left_menu.scss">
/* you can leave this empty or add component-specific overrides */
</style>
